import { cfetch } from '@confluence/network';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

export type SnippetMediaAuth = {
	clientId: string;
	token: string;
	baseUrl: string;
};

const BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';

/**
 * Fetches a media token for a snippet from the Block Service (GET /v1/snippets/{snippetId}/media-token).
 * Returns auth shape compatible with MediaProvider's AuthProvider.
 */
export const fetchSnippetMediaToken = async (snippetId: string): Promise<SnippetMediaAuth> => {
	try {
		const response = await cfetch(
			`${BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`,
			{
				method: 'GET',
				headers: {
					Accept: 'application/json',
				},
			},
		);

		const data: { token: string; config: { clientId: string; fileStoreUrl: string } } =
			await response.json();
		return {
			clientId: data.config.clientId,
			token: data.token,
			baseUrl: data.config.fileStoreUrl,
		};
	} catch (error) {
		getMonitoringClient().submitError(error, {
			attribution: Attribution.INTEGRATIONS,
		});
		throw error;
	}
};
